<template>
  <a-modal
    :visible="visible"
    :destroyOnClose="true"
    :footer="null"
    :centered="true"
    @cancel="$emit('cancel')"
    width="430px"
    wrapClassName="age-limit-modal"
  >
    <div slot="title" class="title">
      <img src="/img/icons/attention.svg" :alt="$t('attention.icon')" class="icon" />
      <h3>{{ $t('attention') }}</h3>
    </div>
    <p>{{ $t('age.limit.modal.p1') }}</p>
    <p class="p2">{{ $t('age.limit.modal.p2') }}</p>
    <a-button type="primary" @click="$emit('cancel')">{{ $t('age.limit.modal.button') }}</a-button>
  </a-modal>
</template>

<script>
export default  {
  props: {
    visible: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/fonts';

.title {
  display: flex;
}
.icon {
  margin-right: 7px;
}
.p2 { 
  color: $grey;
}
p {
  padding-bottom: 8px;
  font-size: $font-size-large;
  color: $dark-grey;
  text-align: center;
}
</style>
<style lang="scss">
.age-limit-modal {
  .ant-modal-title,
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
